import ContentLayout from '@cloudscape-design/components/content-layout';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';

const TranslationsPage = () => {
  return (
    <ContentLayout header={<Header variant="h3">Translations</Header>}>
      <Container>Translations functionality coming soon.</Container>
    </ContentLayout>
  );
};

export default TranslationsPage;
